import { DpContainer } from '@/components/blocks/DpContainer';
import { combineSX } from '@/utils/combineSX';
import { styled, SxProps, Typography } from '@mui/material';

interface DpInformativeContainerProps {
	children: React.ReactNode;
	framesx?: SxProps;
}

export const DpInformativeContainer: React.FC<
	React.PropsWithChildren<DpInformativeContainerProps>
> = ({ children, framesx, ...props }) => (
	<DpContainer
		framesx={combineSX([
			{ paddingBottom: 'var(--spacing-10)', paddingTop: 'var(--spacing-8)' },
			Array.isArray(framesx) ? framesx : [framesx],
		])}
		{...props}
	>
		{children}
	</DpContainer>
);

interface DpInformativeH1Props {
	children: React.ReactNode;
	sx?: SxProps;
}

export const DpInformativeH1: React.FC<React.PropsWithChildren<DpInformativeH1Props>> = ({
	children,
	sx,
	...props
}) => (
	<Typography
		component="h1"
		sx={combineSX([
			{
				mb: 'var(--spacing-4)',
				fontSize: { xs: 'var(--font-size-lg)', md: 'var(--font-size-xl)' },
				fontWeight: 800,
				textTransform: 'uppercase',
			},
			Array.isArray(sx) ? sx : [sx],
		])}
		{...props}
	>
		{children}
	</Typography>
);

interface DpInformativeH3Props {
	children: React.ReactNode;
	yspace?: boolean;
	topspace?: boolean;
	bottomspace?: boolean;
	sx?: SxProps;
}

export const DpInformativeH3: React.FC<React.PropsWithChildren<DpInformativeH3Props>> = ({
	children,
	yspace = true,
	topspace = false,
	bottomspace = true,
	sx,
	...props
}) => (
	<Typography
		component="h3"
		sx={combineSX([
			{
				fontSize: 'var(--font-size-body)',
				fontWeight: 'bold',
				marginTop: topspace ? 'var(--spacing-8)' : yspace ? 'var(--spacing-8)' : 0,
				marginBottom: bottomspace ? 'var(--spacing-1)' : yspace ? 'var(--spacing-1)' : 0,
			},
			...(Array.isArray(sx) ? sx : [sx]),
		])}
		{...props}
	>
		{children}
	</Typography>
);

export const DpInformativeUl = styled('ul')<{
	yspace?: boolean;
	bottomspace?: boolean;
	topspace?: boolean;
}>(({ yspace = false, topspace = false, bottomspace = false }) => ({
	margin: 0,
	marginTop: topspace ? '1rem' : yspace ? '1rem' : 0,
	marginBottom: bottomspace ? '1rem' : yspace ? '1rem' : 0,
}));

export const DpInformativeOl = styled('ol')<{
	yspace?: boolean;
	bottomspace?: boolean;
	topspace?: boolean;
}>(({ yspace = false, bottomspace = false, topspace = false }) => ({
	margin: 0,
	marginTop: topspace ? '1rem' : yspace ? '1rem' : 0,
	marginBottom: bottomspace ? '1rem' : yspace ? '1rem' : 0,
}));

export const DpInformativeLi = styled('li')(() => ({
	fontSize: 'var(--font-size-body)',
}));

export const DpInformativeP = styled('p')(() => ({
	fontSize: 'var(--font-size-body)',
	margin: 0,
}));
